//Campaign Policies agree/disagree 관련 전역 Vuex Store
import axios from '@core_utils/api/_axios.js'
import commonLogout from '@core_utils/common-logout'

const policies = {
    namespaced: true,
    state: {
      is_agree: false,
      policy_content: '',
      policy_content_e: '',
      policy_content_c: '',
      policy_id : null
    },

    getters: {},

    mutations: {
        set_is_agree(state, mode){
            state.is_agree = mode
        },
        update_policy_content(state, new_item){
            state.policy_content = new_item
        },
        update_policy_content_e(state, new_item){
            state.policy_content_e = new_item
        },
        update_policy_content_c(state, new_item){
            state.policy_content_c = new_item
        },
        update_policy_id(state, new_id){
            state.policy_id = new_id
        }
    },

    actions: {
        async readAgree ({ commit }, { company_id, campaign_id }) {
            // 접속한 캠페인의 campaign_id, 로그인한 기업의 company_id 보내서 AGREE 상태 확
            try {
                const response = await axios.get('/read_agree', {
                    params:{ company_id, campaign_id }
                })
    
                let result = response.data 
                if (result.policy_id !== null) {
                    commit('update_policy_id', result.policy_id)
                    commit('update_policy_content', result.contents)
                    commit('update_policy_content_e', result.contents_e)
                    commit('update_policy_content_c', result.contents_c)
                    commit('set_is_agree', result.agree === true)
                } else {
                    commit('update_policy_id', null)
                    commit('update_policy_content', null)
                    commit('update_policy_content_e', null)
                    commit('update_policy_content_c', null)
                    commit('set_is_agree', false)
                }
            } catch (error) {
                console.log(error)
            }
            
        },
        async saveAgree ({ commit, rootState }, { company_id, campaign_id, mode }) {
            //접속한 캠페인의 campaign_id, 로그인한 기업의 company_id 보내서 save 상태 저장
            try {
                const formData = new FormData()
                formData.append('company_id', company_id)
                formData.append('campaign_id', campaign_id)
                formData.append('user_id', rootState.user_id)
                formData.append('agree', mode)
                
                await axios.post('/save_agree', formData)
                commit('set_is_agree', mode)
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await commonLogout()
                    }
                }
            }
        },
    }
}

export default policies